import React from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import { CardActionArea, CardActions } from "@mui/material";
import Link from "@mui/material/Link";
import DownloadIcon from "@mui/icons-material/Download";
import Tooltip from "@mui/material/Tooltip";

const ShowBoxCard = (props) => {
  const navigate = useNavigate();
  const handleClick = () => {
    localStorage.setItem("categoryImage", props.cardData.image);
    localStorage.setItem("categoryTitle", props.cardData.title);
    navigate("/showbox?collectionId=" + props.cardData.slug);
  };

  const sbDownloadLink =
    "https://dvtcbpcfza5s9.cloudfront.net/44BlueProductions/showboxes-archive/" +
    props.cardData.slug +
    ".zip";

  return (
    <>
      <Card sx={{ width: 300, height: 415 }}>
        <ButtonBase onClick={() => handleClick()}>
          <CardActionArea>
            <CardMedia
              component="img"
              sx={{ width: 300, height: 350 }}
              width="300"
              height="350"
              image={props.cardData.image}
              alt="44Blue Productions"
            />
            <CardContent
              style={{ backgroundColor: "#202328", color: "white", height: 80 }}
            >
              <Typography gutterBottom variant="h6" component="div">
                {props.cardData.title}

                <Link
                  style={{ color: "#1897f3", float: "right" }}
                  href={sbDownloadLink}
                >
                  <Tooltip
                    TransitionProps={{ timeout: 600 }}
                    title="Download ShowBox"
                    placement="left"
                    arrow
                  >
                    <DownloadIcon style={{ fontSize: "25px" }} />
                  </Tooltip>
                </Link>
              </Typography>
              {props.cardData.description && (
                <Typography
                  p={1}
                  variant="subtitle1"
                  style={{
                    fontSize: "1.15em",
                    fontStyle: "italic",
                    textAlign: "center",
                  }}
                >
                  {props.cardData.description}.
                </Typography>
              )}
            </CardContent>
          </CardActionArea>
        </ButtonBase>
      </Card>
    </>
  );
};

export default ShowBoxCard;
